import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'quantityPerBranch'
})
export class QuantityPerBranchPipe implements PipeTransform {

  transform(value: any[], branchId): number {
    const productsFilteredPerBranch = value.filter(product => product.branchContactId === branchId);
    const reduced: number = productsFilteredPerBranch.reduce((a, b) => {
      a += b.quantity;
      return a
    }, 0);
    return reduced || 0;
  }

}
